__turbopack_context__.v({
  "firstTabSelected": "TabControl-module__Xbq9IW__firstTabSelected",
  "lastTabSelected": "TabControl-module__Xbq9IW__lastTabSelected",
  "selected": "TabControl-module__Xbq9IW__selected",
  "tabBar": "TabControl-module__Xbq9IW__tabBar",
  "tabControl": "TabControl-module__Xbq9IW__tabControl",
  "tabPage": "TabControl-module__Xbq9IW__tabPage",
  "tabPageInner": "TabControl-module__Xbq9IW__tabPageInner",
});
